import { Image } from "antd";
import { useRef, useState } from "react";
import React from "react";
import moment from "moment";
import "./style/index.scss";
import icon from "../../../../util/assets/icon_login.png";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import { DetalhesFiltrosModel } from "../../../../models/detalhesFiltrosModel";

const LancamentoBancarioPorPlanoContaRelatorio = () => {
  //estados globais
  const part1 = JSON.parse(localStorage.getItem("listLancamentos_part1") || "[]");
  const part2 = JSON.parse(localStorage.getItem("listLancamentos_part2") || "[]");
  const part3 = JSON.parse(localStorage.getItem("listLancamentos_part3") || "[]");
  const listLancamentos = [...part1, ...part2, ...part3];

  const lancamentoBancarioState_busca = JSON.parse(localStorage.getItem("lancamentoBancarioState_busca")!);
  const empresaState = JSON.parse(localStorage.getItem("empresaState")!);
  const configuracoesState = JSON.parse(localStorage.getItem("configuracoesState")!);

  //estados locais
  const relatorioComponentHtml = useRef<HTMLDivElement>(null);
  const [totalGeral, setTotalGeral] = useState<number>(0);

  const TbodyConstruida = () => {
    let auxN1 = "",
      auxN2: string | null = null,
      auxN3: string | null = null;
    let showN1 = false,
      showN2 = false,
      showN3 = false;
    let countN1 = 0,
      countN2 = 0,
      countN3 = 0;
    let totalN1: number[] = [],
      totalN2: number[] = [],
      totalN3: number[] = [];

    let totalG: number = 0;
    return (
      <tbody>
        {listLancamentos.map((item: any, index: any) => {
          showN1 = item.planoContaFinanceiro_N1 !== auxN1;
          showN2 = item.planoContaFinanceiro_N2 !== auxN2;
          showN3 = item.planoContaFinanceiro_N3 !== auxN3;

          if (item.planoContaFinanceiro_N1 !== auxN1) {
            auxN1 = item.planoContaFinanceiro_N1;

            countN1++;
          }
          totalN1[countN1] = (isNaN(totalN1[countN1]) ? 0 : totalN1[countN1]) + item.valor;
          totalG += item.valor;
          setTotalGeral(totalG);

          if (item.planoContaFinanceiro_N2 !== auxN2) {
            auxN2 = item.planoContaFinanceiro_N2;

            countN2++;
          }
          totalN2[countN2] = (isNaN(totalN2[countN2]) ? 0 : totalN2[countN2]) + item.valor;

          if (item.planoContaFinanceiro_N3 !== auxN3) {
            auxN3 = item.planoContaFinanceiro_N3;
            countN3++;
          }
          totalN3[countN3] = (isNaN(totalN3[countN3]) ? 0 : totalN3[countN3]) + item.valor;

          return (
            <React.Fragment key={item.idLancamento}>
              {showN1 && (
                <>
                  {countN1 > 1 && (
                    <>
                      {
                        <>
                          {countN3 > 1 && (
                            <>
                              <tr style={{ backgroundColor: "#eeeeee", fontSize: "11px" }}>
                                <td colSpan={4}>&nbsp;&nbsp;&nbsp;&nbsp;Subtotal</td>
                                <td className="ht-right">{countN3 > 0 ? currencyBRL(totalN3[countN3 - 1]) : currencyBRL(0)}</td>
                              </tr>
                              <tr>
                                <td colSpan={5}>
                                  <div style={{ padding: 2 }}></div>
                                </td>
                              </tr>
                            </>
                          )}
                          <tr style={{ backgroundColor: "#e6e6e6", fontSize: "12px", fontWeight: "bold" }}>
                            <td colSpan={4}>&nbsp;&nbsp;Subtotal</td>
                            <td className="ht-right">{currencyBRL(totalN2[countN2 - 1])}</td>
                          </tr>
                          <tr>
                            <td colSpan={5}>
                              <div style={{ padding: 2 }}></div>
                            </td>
                          </tr>
                          <tr style={{ fontSize: "13px", fontWeight: "bold" }}>
                            <td colSpan={4}>Subtotal</td>
                            <td className="ht-right">{currencyBRL(totalN1[countN1 - 1])}</td>
                          </tr>
                          <tr>
                            <td colSpan={5}>
                              <div style={{ padding: 2 }}></div>
                            </td>
                          </tr>
                        </>
                      }
                    </>
                  )}
                  <tr>
                    <td colSpan={5} style={{ fontSize: "13px", fontWeight: "bold" }}>
                      {auxN1}
                    </td>
                  </tr>
                </>
              )}
              {showN2 && (
                <>
                  {countN2 > 1 && (
                    <>
                      {!showN1 && (
                        <>
                          {countN3 > 1 && (
                            <>
                              <tr style={{ backgroundColor: "#eeeeee", fontSize: "11px" }}>
                                <td colSpan={4}>&nbsp;&nbsp;&nbsp;&nbsp;Subtotal</td>
                                <td className="ht-right">{currencyBRL(totalN3[countN3 - 1])}</td>
                              </tr>
                              <tr>
                                <td colSpan={5}>
                                  <div style={{ padding: 2 }}></div>
                                </td>
                              </tr>
                            </>
                          )}

                          <tr style={{ backgroundColor: "#e6e6e6", fontSize: "12px", fontWeight: "bold" }}>
                            <td colSpan={4}>&nbsp;&nbsp;Subtotal</td>
                            <td className="ht-right">{currencyBRL(totalN2[countN2 - 1])}</td>
                          </tr>
                          <tr>
                            <td colSpan={5}>
                              {" "}
                              <div style={{ padding: 2 }}></div>
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  )}
                  {showN1 && (
                    <tr>
                      <td colSpan={5}>
                        {" "}
                        <div style={{ padding: 2 }}></div>
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td colSpan={5} style={{ fontSize: "12px", fontWeight: "bold", backgroundColor: "#e6e6e6" }}>
                      &nbsp;&nbsp;{auxN2}
                    </td>
                  </tr>
                </>
              )}
              {showN3 && (
                <>
                  {countN3 > 1 && (
                    <>
                      {
                        <>
                          {!showN2 && (
                            <>
                              <tr style={{ backgroundColor: "#eeeeee", fontSize: "11px" }}>
                                <td colSpan={4}>&nbsp;&nbsp;&nbsp;&nbsp;Subtotal</td>
                                <td className="ht-right">{currencyBRL(totalN3[countN3 - 1])}</td>
                              </tr>
                              <tr>
                                <td colSpan={5}>
                                  {" "}
                                  <div style={{ padding: 2 }}></div>
                                </td>
                              </tr>
                            </>
                          )}
                        </>
                      }
                    </>
                  )}
                  <tr>
                    <td colSpan={5} style={{ fontSize: "11px", backgroundColor: "#eeeeee" }}>
                      &nbsp;&nbsp;&nbsp; {auxN3}
                    </td>
                  </tr>
                </>
              )}

              {/* REGISTRO POR NIVEL DE PLANO */}
              <tr style={{ fontSize: "10px" }}>
                <td className="ht-right" style={{ paddingRight: 5 }}>
                  {moment(item.data).format("DD/MM/YYYY")}
                </td>
                <td>{item.clienteFornecedor}</td>
                <td>{item.numeroDocumento}</td>
                <td>{item.historico}</td>
                <td className="ht-right">{currencyBRL(item.valor)}</td>
              </tr>
            </React.Fragment>
          );
        })}
        {totalN3[countN3] && (
          <tr style={{ backgroundColor: "#eeeeee", fontSize: "11px" }}>
            <td colSpan={4}>&nbsp;&nbsp;&nbsp;&nbsp;Subtotal</td>
            <td className="ht-right">{currencyBRL(totalN3[countN3])}</td>
          </tr>
        )}
        {totalN2[countN2] && (
          <>
            <tr>
              <td colSpan={5}>
                {" "}
                <div style={{ padding: 2 }}></div>
              </td>
            </tr>
            <tr style={{ backgroundColor: "#e6e6e6", fontSize: "12px", fontWeight: "bold" }}>
              <td colSpan={4}>&nbsp;&nbsp;Subtotal</td>
              <td className="ht-right">{currencyBRL(totalN2[countN2])}</td>
            </tr>
          </>
        )}
        {totalN1[countN1] && (
          <>
            <tr>
              <td colSpan={5}>
                {" "}
                <div style={{ padding: 2 }}></div>
              </td>
            </tr>
            <tr style={{ fontSize: "13px", fontWeight: "bold" }}>
              <td colSpan={4}>Subtotal</td>
              <td className="ht-right">{currencyBRL(totalN1[countN1])}</td>
            </tr>
          </>
        )}
      </tbody>
    );
  };

  const RelatorioHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
    return (
      <>
        <div ref={ref} className="relatorios-html-format">
          <div className="rel-cabecalho">
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", gap: "24px" }}>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", marginTop: "24px", marginBottom: "24px", marginLeft: "14px" }}>
                <Image preview={false} height={50} src={icon} />
                <div className={"logoText"}>
                  <div className="labelLogoGeral">
                    <span>GRUPO</span>
                  </div>
                  <div className="labelLogoGeral">
                    <span>PASCHOAL</span>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", marginTop: "24px", marginBottom: "24px" }}>
                <div style={{ fontSize: "14px", fontWeight: "bold" }}>RELATÓRIO DE LANÇAMENTOS FINANCEIROS</div>
                <div style={{ fontSize: "13px", marginTop: "10px" }}>
                  <div style={{ display: "flex", gap: 4 }}>
                    <span style={{ fontWeight: "bold" }}>{`Data de ${lancamentoBancarioState_busca.tipoDataFiltro === "SORT" ? "Sorteio" : "Vencimento"}:`}</span>
                    <>{`entre ${moment(lancamentoBancarioState_busca.dataInicio).format("DD/MM/YYYY")} e ${moment(lancamentoBancarioState_busca.dataFim).format("DD/MM/YYYY")}`}</>
                  </div>
                </div>
                <div style={{ fontSize: "13px" }}>
                  <span style={{ fontWeight: "bold" }}>Empresa:</span> {empresaState.list.filter((a: EmpresaModel) => a.id === parseInt(lancamentoBancarioState_busca.idEmpresa.toString()))[0].apelido}
                </div>
                {configuracoesState.filtros.length > 0 && (
                  <div style={{ fontSize: "12px", marginTop: "5px" }}>
                    <div style={{ fontWeight: "bold" }}>Filtros avançados:</div>
                    {configuracoesState.filtros.map((a: DetalhesFiltrosModel, index: any) => {
                      return (
                        <div key={index}>
                          {index + 1 + ". " + a.campo} <strong style={{ fontStyle: "italic" }}>{a.operador}</strong> {a.campo === "Valor" ? currencyBRL(a.valor) : a.valor}
                          {a.valor2 && " e ".concat(currencyBRL(a.valor2))}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="rel-detalhes">
            <table className="tb-dados">
              <thead>
                <tr className="header-table">
                  <th className="ht-right" style={{ width: 70 }}>
                    DATA
                  </th>
                  <th className="ht-left">CLIENTE/FORNECEDOR</th>
                  <th className="ht-left" style={{ width: 100 }}>
                    N. DOC.
                  </th>
                  <th className="ht-left">HISTÓRICO</th>
                  <th className="ht-right" style={{ width: 70 }}>
                    VALOR
                  </th>
                </tr>
              </thead>
              <TbodyConstruida />
            </table>
            <table className="result-footer-table-lb">
              <thead>
                <tr>
                  <th className="ht-left" colSpan={5}>
                    Resultado Geral
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="ht-left" colSpan={4}>
                    Total
                  </td>
                  <td className="ht-right">{currencyBRL(totalGeral)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  });

  return (
    <>
      <RelatorioHtml ref={relatorioComponentHtml}></RelatorioHtml>
    </>
  );
};

export default LancamentoBancarioPorPlanoContaRelatorio;
